
































































































import Vue from "vue";
import { Iaffinity } from "./transform";
import { axios } from "@/plugins";
import { Form } from "element-ui";
interface Ifrom {
  matchExpressions: { key: string; operator: string; values: string[] };
  type: 1 | 0;
  weight: number;
}

const form: Iaffinity = {
  nodeAffinity: {
    requiredDuringSchedulingIgnoredDuringExecution: {
      nodeSelectorTerms: [
        {
          matchExpressions: []
        }
      ]
    },
    preferredDuringSchedulingIgnoredDuringExecution: []
  }
};

const operator = [
  { label: "存在（In）", value: "In" },
  { label: "不存在（NotIn）", value: "NotIn" }
];

export default Vue.extend({
  name: "AffinityEdit",
  data() {
    return {
      dialog: false,
      operator,
      ruleForm: {
        form: [] as Ifrom[]
      },
      labels: {} as any
    };
  },
  methods: {
    show(data?: Iaffinity) {
      if (data) {
        if (
          data.nodeAffinity.requiredDuringSchedulingIgnoredDuringExecution
            ?.nodeSelectorTerms[0]
        ) {
          data.nodeAffinity.requiredDuringSchedulingIgnoredDuringExecution?.nodeSelectorTerms[0].matchExpressions?.forEach(
            item => {
              this.ruleForm.form.push({
                weight: 100,
                type: 0,
                matchExpressions: JSON.parse(JSON.stringify(item))
              });
            }
          );
        }
        if (data.nodeAffinity.preferredDuringSchedulingIgnoredDuringExecution) {
          data.nodeAffinity.preferredDuringSchedulingIgnoredDuringExecution?.forEach(
            item => {
              this.ruleForm.form.push({
                weight: item.weight,
                type: 1,
                matchExpressions: JSON.parse(
                  JSON.stringify(item.preference.matchExpressions[0])
                )
              });
            }
          );
        }
      }

      if (this.ruleForm.form.length === 0) {
        this.addAffi();
      }
      this.dialog = true;
      this.getLabels();
    },
    getLabels() {
      axios.get("/hosts/all/labels").then(res => {
        this.labels = res.data.data;
      });
    },
    getValues(index: number) {
      if (!this.ruleForm.form[index].matchExpressions.key) return [];

      return this.labels[this.ruleForm.form[index].matchExpressions.key];
    },
    quit() {
      this.ruleForm = {
        form: []
      };
      (this.$refs.ruleForm as Form).clearValidate();

      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as any).validate((valid: any) => {
        if (valid) {
          this.create();
        }
      });
    },
    create() {
      if (!this.ruleForm.form.length) {
        this.quit();
      }
      const data: Iaffinity = JSON.parse(JSON.stringify(form));
      this.ruleForm.form.forEach(item => {
        if (item.type === 0) {
          data.nodeAffinity.requiredDuringSchedulingIgnoredDuringExecution?.nodeSelectorTerms[0].matchExpressions.push(
            item.matchExpressions
          );
        } else if (item.type === 1) {
          data.nodeAffinity.preferredDuringSchedulingIgnoredDuringExecution?.push(
            {
              weight: item.weight,
              preference: {
                matchExpressions: [item.matchExpressions]
              }
            }
          );
        }
      });

      this.$emit("afterEdit", data);
      this.quit();
    },
    delAffi(index: number) {
      this.ruleForm.form.splice(index, 1);
    },
    addAffi() {
      this.ruleForm.form.push({
        weight: 100,
        type: 0,
        matchExpressions: {
          key: "",
          operator: "",
          values: []
        }
      });
    }
  }
});
